/** Traductions diagnostic bootstrap storage (FR / AR) */
export const storageBootstrapFr = {
  title: 'Le démarrage est encore en cours…',
  hint:
    'Le système charge encore les données (et du travail continue en arrière-plan). Attendez un peu, ou rechargez l’application.',
  waitingFor: 'En attente de',
  waitingRole: 'rôle utilisateur',
  waitingShell: 'données essentielles (shell)',
  waitingData: 'chargement complet des données',
  waitingAuth: 'authentification / IndexedDB',
  waitingUnknown: 'fin du démarrage',
  backgroundNote:
    'En arrière-plan : ventes/factures, caches, consolidation — cela n’apparaît pas toujours dans la barre de chargement.',
  context: 'Contexte',
  businessId: 'ID commerce',
  dataReady: 'Données prêtes',
  dataLoaded: 'Données chargées',
  shellReady: 'Shell prêt',
  roleReady: 'Rôle prêt',
  yes: 'Oui',
  no: 'Non',
  bootMsDashboard: 'Boot ms → Dashboard',
  idbReadsWrites: 'Lectures / écritures IDB',
  jsonParseStringify: 'JSON parse / stringify',
  repairRunning: 'Réparation…',
  repairLabel: 'Réparer le stockage (si vraiment bloqué)',
  reloadLabel: 'Recharger l\'application',
  waitLabel: 'Continuer d\'attendre',
  repairFailed: 'Réparation échouée : {{message}}',
  repairStep: 'Réparation',
  lastBootGate: 'Dernière étape boot',
  copyDebug: 'Copier le diagnostic',
  copied: 'Copié'
};

export const storageBootstrapAr = {
  title: 'بدء التشغيل ما زال جارياً…',
  hint:
    'النظام ما زال يحمّل البيانات (ويستمر عمل في الخلفية). انتظر قليلاً أو أعد تحميل التطبيق.',
  waitingFor: 'بانتظار',
  waitingRole: 'دور المستخدم',
  waitingShell: 'البيانات الأساسية',
  waitingData: 'اكتمال تحميل البيانات',
  waitingAuth: 'المصادقة / IndexedDB',
  waitingUnknown: 'انتهاء بدء التشغيل',
  backgroundNote:
    'في الخلفية: المبيعات/الفواتير، الذاكرة المؤقتة، الدمج — قد لا يظهر ذلك في شريط التحميل.',
  context: 'السياق',
  businessId: 'معرف النشاط',
  dataReady: 'البيانات جاهزة',
  dataLoaded: 'البيانات محملة',
  shellReady: 'الواجهة جاهزة',
  roleReady: 'الدور جاهز',
  yes: 'نعم',
  no: 'لا',
  bootMsDashboard: 'Boot ms → Dashboard',
  idbReadsWrites: 'قراءات / كتابات IDB',
  jsonParseStringify: 'JSON parse / stringify',
  repairRunning: 'جاري الإصلاح…',
  repairLabel: 'إصلاح التخزين (إذا عالق فعلاً)',
  reloadLabel: 'إعادة تحميل التطبيق',
  waitLabel: 'متابعة الانتظار',
  repairFailed: 'فشل الإصلاح: {{message}}',
  repairStep: 'إصلاح',
  lastBootGate: 'آخر خطوة إقلاع',
  copyDebug: 'نسخ التشخيص',
  copied: 'تم النسخ'
};

